import React, { Component } from 'react';
import { change, Field, reduxForm } from 'redux-form';
import { browserHistory, Link } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withNotify from '../common/withNotify';
import withLoader from '../common/withLoader';
import withUser from '../common/withUser';
import withTeam from '../common/withTeam';
import withOnline from '../common/withOnline';
import ContinueLoginModal from '../components/Models/ContinueLoginModal';
import withSelectCaseDate from '../common/withSelectCaseDate';
import withFirstLoginSessionToken from '../common/withFirstLoginSessionToken';
import withProducts from '../common/withProducts';
import {
  encryptPassword,
  storeUser,
  passwordWithTimestamp,
  storeServerUrl,
  userLogout,
  storeUserNameAndPassword,
  getUserNameAndPassword,
  Fcm_Token,
  storeFirstLoginToken,
  storeVersionCode,
  storeThemeColor,
  storeThemeColorNumber,
  _getPreferredColorScheme
} from '../common/globals';
import {
  getNotifications,
  login,
  reLogin,
  getUsersData
} from '../utils/utils';
import {
  // passwordExtraMatches,
  // passwordMaxLength,
  renderField,
  required
} from '../helpers/form-validations';
import { productDb, deleteDb, getNotSyncdCases } from '../utils/db';
import Bugsnag from '../helpers/bugsnag';
import withServerUrl from '../common/withServerUrl';
import {
  APP_VERSION, REQUEST_SOURCE, APP_GENERATION, API_VERSION_V3
} from '../common/config';
import { requestForToken } from '../helpers/firebase.js';
import { store } from '../redux/store.js';
import { notificationsSet } from '../redux/actions.js';
import withAutoLogin from '../common/withAutoLogin';
import withThemeColor from '../common/withThemeColor';
import withThemeDetectColor from '../common/withThemeDetectColor';
import withThemeNumber from '../common/withThemeNumber';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rememberUserName: false,
      rememberPassword: false,
      formData: {}
    };
    this.continueLoginModal = null;
  }

  componentDidMount() {
    try {
      this.continueLoginModal = new window.bootstrap.Modal(window.$('#continueLoginModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  componentDidUpdate() {
    try {
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onLogin = async (formData) => {
    try {
      const { user } = this.props;
      // Check login scenario
      const getNotSyncedCases = await getNotSyncdCases();
      if (getNotSyncedCases !== undefined && getNotSyncedCases.length > 0) {
        if (user.hasOwnProperty('userId')) {
          if (user.userId.toLowerCase() !== formData.userId.toLowerCase()) {
            this.continueLoginModal.show();
            this.setState({ formData });
            return;
          }
        }
      }

      // if (user.hasOwnProperty('userId')) {
      //   if (user.userId.toLowerCase() !== formData.userId.toLowerCase()) {
      //     this.continueLoginModal.show();
      //     this.setState({ formData });
      //     return;
      //   }
      // }

      // deleteDb();
      this.loginUser(formData);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  loginUser = async (formData) => {
    try {
      const {
        setUser, setLoader, notify, setServerUrl, setTeam, online, setSelectCaseDate, setProducts,
        setFirstLoginSessionToken,
        setThemeColor,
        setThemeColorNumberSet,
        themeDetectColor
      } = this.props;
      const remember = {};
      const { rememberUserName, rememberPassword } = this.state;
      (rememberUserName) ? remember.ru = formData.userId : delete remember.ru;
      (rememberPassword) ? remember.rp = formData.password : delete remember.rp;
      const deviceToken = await requestForToken();
      const loginData = {
        userId: formData.userId,
        password: encryptPassword(passwordWithTimestamp(formData.password)),
        requestSource: REQUEST_SOURCE,
        lastAppVersion: APP_VERSION,
        appGeneration: APP_GENERATION,
        deviceId: deviceToken,
        deviceToken,
        fcmToken: Fcm_Token
      };
      setSelectCaseDate('');
      setProducts([]);

      if (online) {
        setLoader(true);
        const allOfficeDataRes = [];
        login(loginData).then(async (responseJson) => {
          setLoader(false);
          if (responseJson.status) {
            productDb();
            // Add office & team
            responseJson.office = null;
            responseJson.team = null;
            responseJson.loginPayload = loginData;
            responseJson.remember = remember;
            // notify({ type: 'success', message: 'Successfully signed in.', time: 1 });
            setFirstLoginSessionToken(responseJson.sessionToken);
            await storeFirstLoginToken(responseJson.sessionToken);
            await storeUser(responseJson);
            await storeVersionCode();
            setUser(responseJson);
            await storeUserNameAndPassword({});
            getNotifications({ status: 'unread' }).then((notificationsResponse) => {
              if (notificationsResponse) {
                store.dispatch(notificationsSet({
                  totalUnread: notificationsResponse.totalUnread,
                  data: notificationsResponse.notifications
                }));
              }
            });
            const officeData = [];
            for (const office of responseJson.territories) {
              if (office.offices.length > 0) {
                for (const item of office.offices) {
                  officeData.push(item);
                }
              }
            }
            if (!officeData.length > 0) {
              browserHistory.push('/');
              return notify({
                type: 'error',
                message: 'Your account is not configured properly. Please contact your office.',
                time: 10
              });
            }

            const newValue = responseJson.isDarkMode;
            setThemeColorNumberSet(newValue);
            await storeThemeColorNumber(newValue);
            if (newValue === 2) {
              setThemeColor(themeDetectColor);
              await storeThemeColor(themeDetectColor);
            } else if (newValue === 1) {
              setThemeColor('dark');
              await storeThemeColor('dark');
            } else {
              setThemeColor('light');
              await storeThemeColor('light');
            }

            await _getPreferredColorScheme();

            responseJson.territories.map(async (territoriesData) => {
              if (territoriesData.offices.length > 0) {
                allOfficeDataRes.push(territoriesData.offices);
                if (allOfficeDataRes !== undefined && allOfficeDataRes.length > 1) {
                  setTimeout(() => {
                    setUser(responseJson);
                    browserHistory.push('/office');
                  }, 600);
                } else if (allOfficeDataRes.length > 0 && allOfficeDataRes[0][0].teams.length > 1
                  && allOfficeDataRes[0].length > 1) {
                  setTimeout(() => {
                    setUser(responseJson);
                    browserHistory.push('/office');
                  }, 600);
                } else if (allOfficeDataRes.length > 0 && allOfficeDataRes[0][0].teams.length === 1
                  && allOfficeDataRes[0].length === 1) {
                  const officeRes = allOfficeDataRes[0][0];
                  const teamRes = allOfficeDataRes[0][0].teams[0];
                  const territoriesData1 = responseJson.territories.find(
                    (item) => item.offices.some(
                      (office) => office.id === officeRes.id
                    )
                  );
                  const userOfficeData = Object.assign(responseJson,
                    {
                      office: officeRes.id,
                      territoryId: territoriesData1.id,
                      team: teamRes.id,
                      selectedTeam: teamRes
                    });
                  setUser(userOfficeData);
                  const serverData = {
                    server: territoriesData.server,
                    aipUrl: territoriesData.httpUrlApiNew
                  };
                  await storeServerUrl(serverData);
                  setServerUrl(serverData);
                  setTeam(teamRes);
                  storeUser(userOfficeData);
                  storeVersionCode();
                  const reLoginData = {
                    userId: responseJson.loginPayload.userId,
                    password: responseJson.loginPayload.password,
                    requestSource: REQUEST_SOURCE,
                    lastAppVersion: APP_VERSION,
                    appGeneration: APP_GENERATION,
                    deviceId: deviceToken,
                    deviceToken,
                    fcmToken: Fcm_Token
                  };

                  reLogin(reLoginData).then(async (response) => {
                    setLoader(false);
                    const { status } = response;
                    if (status) {
                      // Add office & team
                      response.office = responseJson.office;
                      response.team = responseJson.team;
                      response.territoryId = responseJson.territoryId;
                      response.remember = responseJson.remember;
                      response.selectedTeam = responseJson.selectedTeam;
                      response.loginPayload = reLoginData;
                      await storeUser(response);
                      await storeVersionCode();
                      setUser(response);
                      browserHistory.push('/sync-data');
                    } else {
                      notify({ type: 'error', message: response.message });
                      userLogout(false);
                    }
                  });
                } else {
                  const territoriesData2 = responseJson.territories.find(
                    (item) => item.offices.some(
                      (office) => {
                        if (allOfficeDataRes.length > 0) {
                          if (office.id === allOfficeDataRes[0][0].id) {
                            return item;
                          }
                        }
                      }
                    )
                  );
                  if (allOfficeDataRes.length > 0 && allOfficeDataRes[0][0].teams.length >= 0) {
                    const userData = Object.assign(responseJson,
                      { office: allOfficeDataRes[0][0].id, territoryId: territoriesData2.id });
                    setUser(userData);
                    const serverData = {
                      server: territoriesData2.server,
                      aipUrl: territoriesData2.httpUrlApiNew
                    };
                    await storeServerUrl(serverData);
                    setServerUrl(serverData);
                    storeUser(userData);
                    storeVersionCode();
                    browserHistory.push('/team');
                  } else {
                    notify({
                      type: 'error',
                      message: 'Your account is not configured properly. Please contact your office.',
                      time: 5
                    });
                    browserHistory.push('/team');
                  }
                }
              }
            });
          } else {
            notify({ type: 'error', message: responseJson.message });
          }
        });
      } else {
        notify({ type: 'error', message: 'You must an internet connection to Log In. Please check your connection and try again.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickYes = () => {
    try {
      const { formData } = this.state;
      deleteDb();
      this.loginUser(formData);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangePassword = () => {
    try {
      storeUserNameAndPassword(this.props.formData.values);
      browserHistory.push('/change-password');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onForgotPassword = () => {
    try {
      storeUserNameAndPassword(this.props.formData.values);
      browserHistory.push('/forgot-password');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  autoLoginUser = async (token) => {
    try {
      const {
        setUser, setLoader, notify,
        setServerUrl, setTeam,
        setSelectCaseDate, setProducts,
        setFirstLoginSessionToken, setAutoLoginData
      } = this.props;
      // console.log(this.props);
      const paramData = atob(token);
      const jsonData = JSON.parse(paramData);

      // deleteDb();
      setSelectCaseDate('');
      setProducts([]);

      const getSettingsPayload = {
        userId: jsonData.userId,
        sessionToken: jsonData.token,
        url: atob(jsonData.url)
      };
      let responseJson = {};
      setLoader(true);
      responseJson = await getUsersData(getSettingsPayload);
      const { status } = responseJson;
      if (status) {
        const getUserRes = await getUsersData(getSettingsPayload);
        if (getUserRes.status === true) {
          const remember = {};
          const deviceToken = await requestForToken();
          const loginData = {
            userId: getUserRes.userId,
            requestSource: REQUEST_SOURCE,
            lastAppVersion: APP_VERSION,
            appGeneration: APP_GENERATION,
            deviceId: deviceToken,
            deviceToken,
            fcmToken: Fcm_Token
          };

          productDb();
          // Add office & team
          responseJson.office = null;
          responseJson.team = null;
          responseJson.loginPayload = loginData;
          responseJson.remember = remember;

          setFirstLoginSessionToken(jsonData.firstToken);
          await storeFirstLoginToken(jsonData.firstToken);
          await storeUser(responseJson);
          await storeVersionCode();
          setUser(responseJson);
          await storeUserNameAndPassword({});
          getNotifications({ status: 'unread' }).then((notificationsResponse) => {
            if (notificationsResponse) {
              store.dispatch(notificationsSet({
                totalUnread: notificationsResponse.totalUnread,
                data: notificationsResponse.notifications
              }));
            }
          });
          const officeData = [];
          for (const office of responseJson.territories) {
            if (office.offices.length > 0) {
              for (const item of office.offices) {
                officeData.push(item);
              }
            }
          }

          const allOfficeDataRes = [];
          responseJson.territories.map(async (territoriesData) => {
            if (territoriesData.offices.length > 0) {
              if (Number(territoriesData.id) === Number(jsonData.territoryId)) {
                allOfficeDataRes.push(territoriesData.offices);
                const officeRes = allOfficeDataRes[0].map((obj) => {
                  if (Number(obj.id) === Number(jsonData.office)) {
                    return obj;
                  }
                  return null;
                }).find((obj) => obj !== null);
                const teamRes = officeRes.teams.map((obj) => {
                  if (Number(obj.id) === Number(jsonData.team)) {
                    return obj;
                  }
                  return null;
                }).find((obj) => obj !== null);
                // const territoriesData1 = responseJson.territories.find(
                //   (item) => item.offices.some(
                //     (office) => office.id === officeRes.id
                //   )
                // );
                const userOfficeData = Object.assign(responseJson,
                  {
                    office: officeRes.id,
                    territoryId: jsonData.territoryId,
                    team: teamRes.id,
                    selectedTeam: teamRes
                  });
                setUser(userOfficeData);
                const serverData = {
                  server: territoriesData.server,
                  aipUrl: territoriesData.httpUrlApiNew
                };
                await storeServerUrl(serverData);
                setServerUrl(serverData);
                setTeam(teamRes);
                storeUser(userOfficeData);
                storeVersionCode();
                setAutoLoginData(true);

                responseJson.office = jsonData.office;
                responseJson.team = jsonData.team;
                responseJson.territoryId = jsonData.territoryId;
                responseJson.selectedTeam = teamRes;
                await storeUser(responseJson);
                await storeVersionCode();
                setUser(responseJson);
                browserHistory.push('/sync-data');
              }
            }
          });
        } else {
          notify({ type: 'error', message: getUserRes.message });
        }
      }
      setLoader(false);
      browserHistory.push('/');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { user, dispatch } = this.props;

      // Auto Login
      const query = new URLSearchParams(this.props.location.search);
      if (typeof query !== 'undefined' || query !== null) {
        const token = query.get('auto-login');
        if (typeof token !== 'undefined' || token !== null) {
          try {
            const paramData = atob(token);
            console.log(paramData);
            this.autoLoginUser(token);
          } catch (error) {
            Bugsnag.notify(error);
          }
        }
      }

      const getUserName = await getUserNameAndPassword();
      Object.keys(getUserName).map((key) => {
        dispatch(change('loginForm', key, getUserName[key]));
      });

      if (user.hasOwnProperty('remember')) {
        const { remember } = user;
        this.setState({
          rememberUserName: remember.hasOwnProperty('ru') ? remember.ru !== '' : false,
          rememberPassword: remember.hasOwnProperty('rp') ? remember.rp !== '' : false,
        }, () => {
          dispatch(change('loginForm', 'userId', remember.ru));
          dispatch(change('loginForm', 'password', remember.rp));
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { handleSubmit, themeColor } = this.props;
    const { rememberUserName } = this.state;
    return (
      <div className="site-wrapper">
        <section className="login-section">
          <div className="container">
            <div className="row justify-content-center gx-2">
              <div className="col-12 col-md-6 col-lg-4 col-xl-4">
                <div className="logo-wrap">
                  <Link>
                    <img src={`${themeColor === 'light' ? 'assets/images/dark_report_logo.png' : 'assets/images/white_report_logo.png'}`} alt="logo" />
                  </Link>
                </div>

                <p className="version">v{APP_VERSION} ({API_VERSION_V3})</p>
                <form onSubmit={handleSubmit(this._onLogin)} form="loginForm">
                  <div className="case-data">
                    <label htmlFor="userId">User ID</label>
                    <Field
                      type="text"
                      name="userId"
                      className="form-control"
                      placeholder="User ID"
                      component={renderField}
                      validate={[required]}
                    />
                    <div className="form-check check-reverse mt-2">
                      <label className="form-check-label" htmlFor="rememberID">Remember ID</label>
                      <input
                        id="rememberID"
                        name="rememberUserId"
                        type="checkbox"
                        checked={rememberUserName}
                        className="form-check-input"
                        onChange={() => this.setState({ rememberUserName: !rememberUserName })}
                      />
                    </div>
                  </div>
                  <div className="case-data pt-3">
                    <label htmlFor="password">Password</label>
                    <Field
                      type="password"
                      name="password"
                      className="form-control"
                      placeholder="Password"
                      component={renderField}
                      // validate={[required, passwordMaxLength, passwordExtraMatches]}
                      validate={[required]}
                    />
                    {/* <div className="form-check check-reverse mt-2"> */}
                    {/*  <label className="form-check-label" htmlFor="rememberPassword"> */}
                    {/* Remember Password</label> */}
                    {/*  <input */}
                    {/*    id="rememberPassword" */}
                    {/*    name="rememberPassword" */}
                    {/*    type="checkbox" */}
                    {/*    checked={rememberPassword} */}
                    {/*    className="form-check-input" */}
                    {/*    onChange={() => this.setState({ */}
                    {/*  rememberPassword: !rememberPassword })} */}
                    {/*  /> */}
                    {/* </div> */}
                  </div>

                  <div className="case-data pt-5 mb-4">
                    <button type="submit" className="btn btn-theme-alt w-100">Log In</button>
                  </div>
                  <div className="row gx-2">
                    <div className="col-6">
                      <button className="btn btn-theme-alt btn-theme-outline-alt w-100" onClick={this._onForgotPassword}>Forgot Password</button>
                    </div>
                    <div className="col-6">
                      <button className="btn btn-theme-alt btn-theme-outline-alt w-100" onClick={this._onChangePassword}>Change Password</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </section>
        <ContinueLoginModal onClickYes={this._onClickYes} />
      </div>
    );
  }
}

/* const withForm = reduxForm({
  enableReinitialize: true,
  form: 'loginForm',
}); */

const loginFormProps = withFirstLoginSessionToken(
  withProducts(
    withSelectCaseDate(
      withOnline(
        withTeam(
          withServerUrl(
            withUser(
              withNotify(
                withLoader(
                  withAutoLogin(
                    withThemeDetectColor(
                      withThemeColor(
                        withThemeNumber(
                          Login
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);

export default compose(
  connect((state) => ({
    formData: state.form.loginForm
  })),
  reduxForm({ form: 'loginForm' })
)(loginFormProps);
